export default __webpack_public_path__ + "static/media/menu_link_settings_not_selected.1be99606.svg";